import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "grid align-items-end" }
const _hoisted_3 = { class: "col-12 md:col-3" }
const _hoisted_4 = { class: "p-fluid" }
const _hoisted_5 = { class: "col-12 md:col-3" }
const _hoisted_6 = { class: "p-fluid" }
const _hoisted_7 = { class: "col-12 md:col-3" }
const _hoisted_8 = { class: "p-fluid" }
const _hoisted_9 = { class: "col-12 md:col-3" }
const _hoisted_10 = {
  key: 0,
  class: "col-12"
}
const _hoisted_11 = { class: "text-xs" }
const _hoisted_12 = {
  key: 0,
  class: "grid mb-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_FieldDropdownAutoComplete = _resolveComponent("FieldDropdownAutoComplete")!
  const _component_FieldText = _resolveComponent("FieldText")!
  const _component_FieldDropdownAutoCompleteMultiple = _resolveComponent("FieldDropdownAutoCompleteMultiple")!
  const _component_PrimeVueButton = _resolveComponent("PrimeVueButton")!
  const _component_FeedCreativeCard = _resolveComponent("FeedCreativeCard")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header, {
      class: "mb-3",
      title: "Live Feeds Creatives"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_FieldDropdownAutoComplete, {
              class: "mb-0",
              modelValue: _ctx.endpointId,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.endpointId) = $event)),
              label: _ctx.$t('endpoint'),
              "show-clear": "",
              "api-url": "/api/v3/endpoints/options",
              "api-params": { 'filter[status]': '1', 'filter[traffic_type]': '2,3', 'include': 'project,user' },
              "option-label": "compiled_name"
            }, null, 8, ["modelValue", "label"])
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_FieldText, {
              modelValue: _ctx.subid,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.subid) = $event)),
              label: _ctx.$t('subid'),
              style: {"margin-bottom":"0 !important"}
            }, null, 8, ["modelValue", "label"])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_FieldDropdownAutoCompleteMultiple, {
              class: "mb-0",
              modelValue: _ctx.feedsIds,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.feedsIds) = $event)),
              label: _ctx.$t('feed'),
              "show-clear": "",
              "api-url": "/api/v3/feeds/options",
              "api-params": { 'filter[status]': '1', 'filter[traffic_type]': '2,3', 'include': 'project' },
              "option-label": "compiled_name"
            }, null, 8, ["modelValue", "label"])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_PrimeVueButton, {
            class: "w-full",
            label: _ctx.$t('preview'),
            loading: _ctx.feedsCreativesLoading,
            disabled: !_ctx.endpointId || !_ctx.subid || _ctx.feedsCreativesLoading,
            onClick: _ctx.fetchCreatives
          }, null, 8, ["label", "loading", "disabled", "onClick"])
        ]),
        (_ctx.clientContext)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "text-xs text-gray-300" }, "Context:", -1)),
              _createElementVNode("code", _hoisted_11, _toDisplayString(_ctx.clientContext), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.feedsCreatives.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.feedsCreatives, (creative, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "col-12 sm:col-6 md:col-3 lg:col-2",
              key: index
            }, [
              _createVNode(_component_FeedCreativeCard, { creative: creative }, {
                "feed-name": _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.feedOptionsMap[creative.feed_id]?.compiled_name || `#${creative.feed_id}`), 1)
                ]),
                _: 2
              }, 1032, ["creative"])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}